import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Select from 'common/components/form/inputs/Select';

import { useActions } from 'utils/hooks';
import * as listActions from 'store/lists/actions';

const LogsStatusSelector = ({ filter, value, onChange, label, placeholder }) => {
  const [fetchListOptions] = useActions([listActions.fetchListOptions]);
  const logsStatuses = useSelector(state => state.lists['logs-statuses']);

  useEffect(() => {
    if (!logsStatuses.options.length) fetchListOptions('logs-statuses');
  }, []);

  return (
    <Select
      label={label}
      placeholder={placeholder ? placeholder : 'Select value'}
      getOptionValue={option => option.level}
      getOptionLabel={option => option.level}
      value={filter ? (filter.value && Array.isArray(filter.value) ? filter.value : []) : value}
      options={logsStatuses.options}
      isMulti={true}
      onChange={selected =>
        onChange({
          data: selected ? selected : [],
          value: selected ? selected : ''
        })
      }
      isClearable
    />
  );
};

export default LogsStatusSelector;
